export function defaultValue(defaultVal, value) {
  if (value !== undefined) return exec(value);
  return exec;

  function exec(arg) {
    return arg === undefined || arg === '' ? defaultVal : arg;
  }
}

export function setHtml(content, elem) {
  const el = document.querySelector(elem.cssPath);
  el.innerHTML = content;
}

export function makeBtn(cssPath) {
  return { type: '$Button', cssPath };
}

export function makeText(cssPath) {
  return { type: '$Text', cssPath };
}
